import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ user, role, children }) {
  const location = useLocation();
  
  // If there's no user token stored, redirect to OAuth callback handler
  if (!user) {
    // Capture the current path to redirect back after login
    const returnTo = encodeURIComponent(location.pathname + location.search + location.hash);
    return <Navigate to={`/auth/success?returnTo=${returnTo}`} replace />;
  }
  // If the user’s role doesn’t match, show an access‐denied message
  if (user.role !== role) {
    return (
      <div className="text-center text-red-500 mt-10">
        Access Denied: You must be a&nbsp;
        <span className="font-semibold">{role}</span>
      </div>
    );
  }
  // Otherwise render the protected UI
  return children;
}
